import callAPiBase from './base';

// v2: conversationStatus is no longer a filter parameter (single table)
const filterUsersApi = {
  filterUserByName: ({ username }: { username: string }) =>
    callAPiBase({
      endpoint: `/api/filter/user/name?username=${encodeURIComponent(
        username,
      )}`,
      method: 'GET',
      useToken: true,
    }),

  filterUserByTag: ({ tagId }: { tagId: string }) =>
    callAPiBase({
      endpoint: `/api/filter/user/tag?tagId=${encodeURIComponent(tagId)}`,
      method: 'GET',
      useToken: true,
    }),

  filterUserByMessage: ({ message }: { message: string }) =>
    callAPiBase({
      endpoint: `/api/filter/user/message?message=${encodeURIComponent(
        message,
      )}`,
      method: 'GET',
      useToken: true,
    }),

  filterTagByName: ({ tag }: { tag: string }) =>
    callAPiBase({
      endpoint: `/api/filter/tag?tag=${encodeURIComponent(tag)}`,
      method: 'GET',
      useToken: true,
    }),
};

export { filterUsersApi };
export default filterUsersApi;
